<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const conseilTypeOptions = [
        `Conseil juridique`,
        `Conseil fiscal`,
        `Assistance comptable`,
        `Création d'entreprise`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const defisBesoinsOptions = [
        `Gestion fiscale`,
        `Recouvrement de créances`,
        `Rédaction de contrats`,
        `Audit financier`,
        `Gestion des ressources humaines`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const profilOptions = [
        `Entreprise`,
        `Entrepreneur indépendant`,
        `Particulier`,
        `Association / ONG`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.conseilJuridique.conseilType}
        class=""
        let:field
        let:id
        label={`Quel type de conseil recherchez-vous principalement ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={conseilTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.conseilJuridique.defisBesoins}
        class=""
        let:field
        let:id
        label={`Quels sont les principaux défis ou besoins auxquels vous faites face actuellement ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={defisBesoinsOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.conseilJuridique.profil}
        class=""
        let:field
        let:id
        label={`Quel est votre profil ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={profilOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
